import styled from 'styled-components';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div`
	width: 100%;
	background-color: rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	border: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledInfoContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	padding: 20px;
	background: rgba(255, 255, 255, 0.1);
	border-radius: 10px 10px 0 0;

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		opacity: 0.5;
	}

	${TextLabel} {
		font-style: italic;
		font-weight: 400;
		font-size: 14px;
		line-height: 16px;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledStateContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 17px;
	padding: 17px 20px 20px;
`;

export { StyledContainer, StyledInfoContainer, StyledStateContainer };
